// @flow

import React from 'react'
import styled from 'styled-components'
import ReviewRoomCard from 'components/molecules/ReviewRoomCard'
import ReviewOwnerBox from 'components/molecules/ReviewOwnerBox'

const SideBar = styled.div`
  position: relative;
`

const Space = styled.div`
  padding: 6px;
`

export type PropTypes = {
  owner: Object,
  room: Object,
}

export default (props: PropTypes) => (
  <SideBar>
    <ReviewRoomCard {...props.room} />
    <Space />
    <ReviewOwnerBox {...props.owner} />
  </SideBar>
)



// WEBPACK FOOTER //
// ./src/components/organisms/ReviewSideBar/index.jsx